import { cn } from "@/lib/utils";

type HairlineDividerProps = {
	className?: string;
};

// 1px horizontal rule using --color-rule.
export function HairlineDivider({ className }: HairlineDividerProps) {
	return <hr className={cn("h-px w-full border-none bg-rule", className)} />;
}
